import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function TrustBadges() {
  return <footer className="w-full bg-slate-50 border-t border-slate-200 mt-16 py-12 px-4" data-id="element-43">
      <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-44">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-8" data-id="element-45">
          <div className="flex items-center gap-3" data-id="element-46">
            <ShieldCheck className="w-8 h-8 text-slate-400" data-id="element-47" />
            <span className="font-semibold text-slate-600" data-id="element-48">
              Garantía 7 días
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-49">
            <Lock className="w-8 h-8 text-slate-400" data-id="element-50" />
            <span className="font-semibold text-slate-600" data-id="element-51">
              Seguridad Bancaria
            </span>
          </div>
        </div>
        <p className="text-sm text-slate-400 text-center" data-id="element-52">
          © {new Date().getFullYear()} Club de Tendencias. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}